import * as ActivityTracker from '@telstra-connect/utils/activity-tracking';

declare var s: {
    track: (name: string, parameter: object) => void;
};

interface IActivityTracker extends ActivityTracker.IActivityTracker {}

const routePrefix = '/app/';

const Activity = {
    trackPage(url: string) {
        // tslint:disable-next-line:no-string-literal
        if (!url || !window['s']) {
            return;
        }

        const pageName = url.startsWith(routePrefix) ?
            url.substring(routePrefix.length) : url;

        s.track('page', { pageName });
    },

    trackLink: (applicationPrefix: string) => (parentComponentName: string, name: string) => {
        // tslint:disable-next-line:no-string-literal
        if (!window['s']) {
            return;
        }

        if (!applicationPrefix) {
            throw new Error('applicationPrefix is mandatory');
        }

        if (!parentComponentName) {
            throw new Error('parentComponentName is mandatory');
        }

        if (!name) {
            throw new Error('link name is mandatory');
        }

        s.track('link', { linkName: `${applicationPrefix}:${parentComponentName}:${name}` });
    },

    createTracker(applicationPrefix: string): IActivityTracker {
        return {
            trackTile: (name: string) => {
                Activity.trackLink(applicationPrefix)('tile', name);
            },

            trackMenu: (name: string) => {
                Activity.trackLink(applicationPrefix)('menu', name);
            },

            trackLink: Activity.trackLink(applicationPrefix)
        };
    }
};

export { IActivityTracker, Activity };
